import { resolveNarrationLang } from '../../narration/lang-map';
import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
const phoneLib = require('phone');

export default class LeadGenerationPopup {
  constructor(options) {
    this._json = options.avatarJson || {};
    this._type = options.type || 'REAL_ESTATE';
    this._onComplete = typeof options.onComplete === 'function' ? options.onComplete : null;
    // Click outside / Esc: the visitor backed out — close without starting the
    // guide (it used to start it with an empty lead, bypassing the form).
    this._onCancel = typeof options.onCancel === 'function' ? options.onCancel : null;
    this._overlay = null;
    const ts = options.translateService || null;
    this._t = (key, fallback) => {
      if (!ts) return fallback;
      const val = ts.translate(key);
      return (val && val !== key) ? val : fallback;
    };
    this._build();
  }

  _build() {
    const overlay = document.createElement('div');
    overlay.className = 'leadgen';

    const backdrop = document.createElement('div');
    backdrop.className = 'leadgen__backdrop';
    backdrop.addEventListener('click', () => this.cancel());

    const container = document.createElement('div');
    container.className = 'leadgen__container';
    container.addEventListener('click', (e) => e.stopPropagation());

    const title = document.createElement('h3');
    title.className = 'leadgen__title';
    title.textContent = this._t('LEADGEN_TITLE', 'Start tour');

    const form = document.createElement('div');
    form.className = 'leadgen__form';

    const makeInput = (labelText, type, name, placeholder) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'leadgen__field';
      const label = document.createElement('label');
      label.className = 'leadgen__label';
      label.textContent = labelText;
      const input = document.createElement('input');
      input.className = 'leadgen__input';
      input.type = type;
      input.name = name;
      input.placeholder = placeholder || '';
      wrapper.appendChild(label);
      wrapper.appendChild(input);
      form.appendChild(wrapper);
      return input;
    };

    const tFirstName = this._t('LEADGEN_FIRST_NAME', 'First name');
    const tSurname   = this._t('LEADGEN_SURNAME', 'Surname');
    const tPhone     = this._t('LEADGEN_PHONE', 'Phone');
    const tEmail     = this._t('LEADGEN_EMAIL', 'Email');
    const tLanguage  = this._t('LEADGEN_LANGUAGE', 'Language');

    const firstNameInput = makeInput(tFirstName, 'text', 'first_name', this._t('LEADGEN_FIRST_NAME_PLACEHOLDER', 'Enter your first name'));
    const surnameInput   = makeInput(tSurname,   'text', 'surname',    this._t('LEADGEN_SURNAME_PLACEHOLDER', 'Enter your surname'));
    const phoneInput     = makeInput(tPhone,     'tel',  'phone',      this._t('LEADGEN_PHONE_PLACEHOLDER', 'Your phone number'));
    const emailInput     = makeInput(tEmail,     'email', 'email',     'name@example.com');

    this._iti = intlTelInput(phoneInput, {
      preferredCountries: ['gb', 'us', 'au', 'ca', 'za', 'ae'],
      nationalMode: true,
    });

    const genderWrapper = document.createElement('div');
    genderWrapper.className = 'leadgen__field';
    const genderLabel = document.createElement('label');
    genderLabel.className = 'leadgen__label';
    genderLabel.textContent = this._t('LEADGEN_GENDER', 'Gender');
    const genderSelect = document.createElement('select');
    genderSelect.className = 'leadgen__select';
    [
      { value: '', label: this._t('LEADGEN_GENDER_PREFER_NOT', 'Prefer not to say') },
      { value: 'male',   label: this._t('LEADGEN_GENDER_MALE',   'Male') },
      { value: 'female', label: this._t('LEADGEN_GENDER_FEMALE', 'Female') },
      { value: 'other',  label: this._t('LEADGEN_GENDER_OTHER',  'Other') },
    ].forEach(g => {
      const opt = document.createElement('option');
      opt.value = g.value;
      opt.textContent = g.label;
      genderSelect.appendChild(opt);
    });
    genderWrapper.appendChild(genderLabel);
    genderWrapper.appendChild(genderSelect);
    form.appendChild(genderWrapper);

    const langWrapper = document.createElement('div');
    langWrapper.className = 'leadgen__field';
    const langLabel = document.createElement('label');
    langLabel.className = 'leadgen__label';
    langLabel.textContent = tLanguage;
    const langSelect = document.createElement('select');
    langSelect.className = 'leadgen__select';

    const languages = [
      { value: 'en', label: '🇬🇧 English' },
      { value: 'en-us', label: '🇺🇸 English (US)' },
      { value: 'en-au', label: '🇦🇺 English (Australia)' },
      { value: 'en-ca', label: '🇨🇦 English (Canada)' },
      { value: 'en-in', label: '🇮🇳 English (India)' },
      { value: 'es', label: '🇪🇸 Español' },
      { value: 'es-mx', label: '🇲🇽 Español (México)' },
      { value: 'es-ar', label: '🇦🇷 Español (Argentina)' },
      { value: 'es-co', label: '🇨🇴 Español (Colombia)' },
      { value: 'fr', label: '🇫🇷 Français' },
      { value: 'fr-ca', label: '🇨🇦 Français (Canada)' },
      { value: 'de', label: '🇩🇪 Deutsch' },
      { value: 'it', label: '🇮🇹 Italiano' },
      { value: 'pt', label: '🇵🇹 Português' },
      { value: 'pt-br', label: '🇧🇷 Português (Brasil)' },
      { value: 'nl', label: '🇳🇱 Nederlands' },
      { value: 'nl-be', label: '🇧🇪 Nederlands (België)' },
      { value: 'sv', label: '🇸🇪 Svenska' },
      { value: 'no', label: '🇳🇴 Norsk' },
      { value: 'da', label: '🇩🇰 Dansk' },
      { value: 'fi', label: '🇫🇮 Suomi' },
      { value: 'is', label: '🇮🇸 Íslenska' },
      { value: 'pl', label: '🇵🇱 Polski' },
      { value: 'cs', label: '🇨🇿 Čeština' },
      { value: 'sk', label: '🇸🇰 Slovenčina' },
      { value: 'sl', label: '🇸🇮 Slovenščina' },
      { value: 'hu', label: '🇭🇺 Magyar' },
      { value: 'ro', label: '🇷🇴 Română' },
      { value: 'bg', label: '🇧🇬 Български' },
      { value: 'uk', label: '🇺🇦 Українська' },
      { value: 'ru', label: '🇷🇺 Русский' },
      { value: 'be', label: '🇧🇾 Беларуская' },
      { value: 'sr', label: '🇷🇸 Српски' },
      { value: 'hr', label: '🇭🇷 Hrvatski' },
      { value: 'bs', label: '🇧🇦 Bosanski' },
      { value: 'mk', label: '🇲🇰 Македонски' },
      { value: 'el', label: '🇬🇷 Ελληνικά' },
      { value: 'tr', label: '🇹🇷 Türkçe' },
      { value: 'sq', label: '🇦🇱 Shqip' },
      { value: 'et', label: '🇪🇪 Eesti' },
      { value: 'lv', label: '🇱🇻 Latviešu' },
      { value: 'lt', label: '🇱🇹 Lietuvių' },
      { value: 'zh-cn', label: '🇨🇳 中文 (简体)' },
      { value: 'zh-tw', label: '🇹🇼 中文 (繁體)' },
      { value: 'zh-hk', label: '🇭🇰 中文 (香港)' },
      { value: 'ja', label: '🇯🇵 日本語' },
      { value: 'ko', label: '🇰🇷 한국어' },
      { value: 'th', label: '🇹🇭 ไทย' },
      { value: 'vi', label: '🇻🇳 Tiếng Việt' },
      { value: 'id', label: '🇮🇩 Bahasa Indonesia' },
      { value: 'ms', label: '🇲🇾 Bahasa Melayu' },
      { value: 'tl', label: '🇵🇭 Filipino' },
      { value: 'hi', label: '🇮🇳 हिन्दी' },
      { value: 'bn', label: '🇧🇩 বাংলা' },
      { value: 'pa', label: '🇮🇳 ਪੰਜਾਬੀ' },
      { value: 'gu', label: '🇮🇳 ગુજરાતી' },
      { value: 'ta', label: '🇮🇳 தமிழ்' },
      { value: 'te', label: '🇮🇳 తెలుగు' },
      { value: 'ml', label: '🇮🇳 മലയാളം' },
      { value: 'mr', label: '🇮🇳 मराठी' },
      { value: 'ur', label: '🇵🇰 اردو' },
      { value: 'fa', label: '🇮🇷 فارسی' },
      { value: 'ar', label: '🇸🇦 العربية' },
      { value: 'ar-eg', label: '🇪🇬 العربية (مصر)' },
      { value: 'ar-ma', label: '🇲🇦 العربية (المغرب)' },
      { value: 'he', label: '🇮🇱 עברית' },
      { value: 'sw', label: '🇰🇪 Kiswahili' },
      { value: 'am', label: '🇪🇹 አማርኛ' },
      { value: 'om', label: '🇪🇹 Afaan Oromoo' },
      { value: 'so', label: '🇸🇴 Af-Soomaali' },
      { value: 'ha', label: '🇳🇬 Hausa' },
      { value: 'yo', label: '🇳🇬 Yorùbá' },
      { value: 'ig', label: '🇳🇬 Igbo' },
      { value: 'zu', label: '🇿🇦 isiZulu' },
      { value: 'xh', label: '🇿🇦 isiXhosa' },
      { value: 'af', label: '🇿🇦 Afrikaans' },
      { value: 'kk', label: '🇰🇿 Қазақ' },
      { value: 'uz', label: '🇺🇿 Oʻzbek' },
      { value: 'ky', label: '🇰🇬 Кыргызча' },
      { value: 'mn', label: '🇲🇳 Монгол' },
      { value: 'ne', label: '🇳🇵 नेपाली' },
      { value: 'si', label: '🇱🇰 සිංහල' },
      { value: 'km', label: '🇰🇭 ភាសាខ្មែរ' },
      { value: 'lo', label: '🇱🇦 ລາວ' },
      { value: 'my', label: '🇲🇲 မြန်မာ' },
      { value: 'ga', label: '🇮🇪 Gaeilge' },
      { value: 'cy', label: '🇬🇧 Cymraeg' },
      { value: 'mt', label: '🇲🇹 Malti' },
      { value: 'lb', label: '🇱🇺 Lëtzebuergesch' },
      { value: 'ca', label: '🇪🇸 Català' },
      { value: 'eu', label: '🇪🇸 Euskara' },
      { value: 'gl', label: '🇪🇸 Galego' },
      { value: 'kk-latn', label: '🇰🇿 Qazaq (Latin)' },
      { value: 'sr-latn', label: '🇷🇸 Srpski (Latinica)' },
      { value: 'az', label: '🇦🇿 Azərbaycanca' },
      { value: 'ka', label: '🇬🇪 ქართული' },
      { value: 'hy', label: '🇦🇲 Հայերեն' },
      { value: 'tt', label: '🇷🇺 Татарча' },
      { value: 'ug', label: '🇨🇳 ئۇيغۇرچە' },
      { value: 'ps', label: '🇦🇫 پښتو' },
      { value: 'sd', label: '🇵🇰 سنڌي' },
      { value: 'ckb', label: '🇮🇶 کوردی' },
      { value: 'fil', label: '🇵🇭 Filipino (Tagalog)' }
    ];
    languages.forEach(l => {
      const opt = document.createElement('option');
      opt.value = l.value;
      opt.textContent = l.label;
      langSelect.appendChild(opt);
    });
    langSelect.value = this._json.defaultLang || this._json.language_code || 'en';

    langWrapper.appendChild(langLabel);
    langWrapper.appendChild(langSelect);
    form.appendChild(langWrapper);

    const errorEl = document.createElement('div');
    errorEl.className = 'leadgen__error';

    const buttonWrapper = document.createElement('div');
    buttonWrapper.className = 'leadgen__actions';

    const startButton = document.createElement('button');
    startButton.type = 'button';
    startButton.className = 'btn eyespy-btn-secondary';
    startButton.textContent = this._t('LEADGEN_START', 'Start');

    const submit = () => {
      const firstName = (firstNameInput.value || '').trim();
      const surname = (surnameInput.value || '').trim();
      const phone = (phoneInput.value || '').trim();
      const email = (emailInput.value || '').trim();
      const selectedLang = (langSelect.value || '').trim() || 'en';
      const supportedLangs = this._json.langs || [];
      let lang = selectedLang;
      if (supportedLangs.length && !supportedLangs.includes(selectedLang)) {
        const base = selectedLang.split('-')[0];
        lang = resolveNarrationLang(base, supportedLangs);
      }

      const missing = [];
      if (!firstName) missing.push(tFirstName);
      if (!surname) missing.push(tSurname);
      if (!phone) missing.push(tPhone);
      if (!email) missing.push(tEmail);
      if (!lang) missing.push(tLanguage);

      if (missing.length) {
        errorEl.textContent = `${this._t('LEADGEN_FILL_REQUIRED', 'Please fill: ')}${missing.join(', ')}`;
        return;
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (email && !emailPattern.test(email)) {
        errorEl.textContent = this._t('LEADGEN_INVALID_EMAIL', 'Please enter a valid email address');
        return;
      }

      let phoneStored = '';
      if (phone) {
        // Build full number: if user typed local format, prepend country dial code
        let fullPhone = phone;
        if (!phone.startsWith('+') && this._iti) {
          const dialCode = this._iti.getSelectedCountryData().dialCode || '';
          fullPhone = `+${dialCode}${phone.replace(/^0+/, '')}`;
        }
        const arrPhone = phoneLib(fullPhone);
        if (!arrPhone.length) {
          errorEl.textContent = this._t('LEADGEN_INVALID_PHONE', 'Please enter a valid phone number');
          return;
        }
        phoneStored = arrPhone[0]; // normalized E.164
      }

      this._json.lead = {
        first_name: firstName,
        surname: surname,
        phone: phoneStored,
        email: email,
        gender: genderSelect.value || '',
        lang: lang
      };
      this._json.language_code = lang;

      if (typeof this._onComplete === 'function') {
        this._onComplete(this._json);
      }

      this.destroy();
    };
    startButton.addEventListener('click', submit);

    // Enter submits from any field; Esc backs out like a click outside.
    this._onKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        this.cancel();
      } else if (e.key === 'Enter' && container.contains(e.target)) {
        e.preventDefault();
        submit();
      }
    };
    document.addEventListener('keydown', this._onKeyDown);

    buttonWrapper.appendChild(startButton);

    container.appendChild(title);
    container.appendChild(form);
    container.appendChild(errorEl);
    container.appendChild(buttonWrapper);

    overlay.appendChild(backdrop);
    overlay.appendChild(container);
    document.body.appendChild(overlay);

    this._overlay = overlay;
  }

  cancel() {
    if (!this._overlay) return;
    this.destroy();
    if (this._onCancel) this._onCancel();
  }

  destroy() {
    if (this._onKeyDown) {
      document.removeEventListener('keydown', this._onKeyDown);
      this._onKeyDown = null;
    }
    if (this._iti) {
      this._iti.destroy();
      this._iti = null;
    }
    if (this._overlay && this._overlay.parentNode) {
      this._overlay.parentNode.removeChild(this._overlay);
    }
    this._overlay = null;
  }
}
